import React from 'react';
import Container from '../../components/Container';
import Input from '../../components/Form/Input';
import useForm from '../../hooks/useForm';
import {Form, Submit, AccordeonContainer} from './styled';
import {UserContext} from '../../UserContext';
import {api} from '../../services/api';
import {Accordion, AccordionDetails, AccordionSummary, Checkbox, createStyles, Theme, FormControlLabel, makeStyles, withStyles, Snackbar, Typography, Modal, ImageList, ImageListItem, ImageListItemBar, IconButton} from '@material-ui/core';
import MuiAlert, {AlertProps} from '@material-ui/lab/Alert';
import Alert from '@material-ui/lab/Alert';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from "date-fns/locale";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import moment from 'moment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid } from '../Home/styled';
import Button from '@material-ui/core/Button';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import JSZip from 'jszip';
import Backdrop from '@material-ui/core/Backdrop';
import { ProgressContent } from '../Repository/Show/styled';
import Fade from '@material-ui/core/Fade';
import LinearProgress from '@material-ui/core/LinearProgress';
import CodeIcon from '@material-ui/icons/Code';
import {default as ButtonMine} from '../../components/Button';
import { CSVLink } from 'react-csv';
import DescriptionIcon from '@material-ui/icons/Description';
import {IoMdImages} from 'react-icons/io';
import { Link } from 'react-router-dom';
import { Pagination } from '@material-ui/lab';
import { RequestsProps } from '../../interfaces';
import JSZipUtils from "jszip-utils"; 

function AlertDark(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    pagination: {
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center',
        marginTop: 10
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
      marginLeft: 10
    },
    paper: {
        backgroundColor: '#fff',
        boxShadow: theme.shadows[5],
        width: '100%',
        maxWidth: '500px',
        borderRadius: 7,
        maxHeight: '90vh',
        textAlign: 'center',
        padding: 20
    },
  }),
);

const useColorlibStepIconStyles = makeStyles({
    root: {
        marginRight: 10
    },   
    alert: {
        marginBottom: 20
    },   
    button: {
        marginTop: 20,
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },    
    rootAccordeon: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: "#fff",
    },
    imageList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    title: {
        color: "#FFF",
    },
    titleBar: {
        background:
        'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
});

const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
        height: 30,
        borderRadius: 30,
        border: "1px solid #ededed",
        boxShadow: "inset 0px 0px 10px -6px rgba(0,0,0,0.75)"
    },
    colorPrimary: {
        background: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQIW2NkQAKrVq36zwjjgzhhYWGMYAEYB8RmROaABADeOQ8CXl/xfgAAAABJRU5ErkJggg==') repeat"
    },
    bar: {
        borderRadius: 5,
        backgroundColor: '#4834d4',
    },
  }),
)(LinearProgress);

const headers = [
    {label: "PK", key: "PK"},
    {label: "PKAvaliacaoProduto", key: "PKAvaliacaoProduto"},
    {label: "boolCurtiu", key: "boolCurtiu"},
    {label: "iAtributosProduto", key: "iAtributosProduto"},
    {label: "iNumeroPedido", key: "iNumeroPedido"},
    {label: "iQMM", key: "iQMM"},
    {label: "iQtdEstrelas", key: "iQtdEstrelas"},
    {label: "iRepositorio", key: "iRepositorio"},
    {label: "nPrecoUnitario", key: "nPrecoUnitario"},
    {label: "nQtde", key: "nQtde"},
    {label: "sCodigo", key: "sCodigo"},
    {label: "sCodigoBarras", key: "sCodigoBarras"},
    {label: "sDescricao", key: "sDescricao"},
    {label: "sNomeArquivo", key: "sNomeArquivo"},
    {label: "sUnidade1", key: "sUnidade1"},
    {label: "average_image_url", key: "average_image_url"},
];

const PedidosPorPagina = 5;

const MyRequests: React.FC = () => {
    document.title = "Meus Pedidos - Sultan Veste a Casa";

    const [requests, setRequests] = React.useState<RequestsProps[]>([]);
    const [group, setGroup] = React.useState(false);
    const [error, setError] = React.useState('');
    const [info, setInfo] = React.useState('');
    const [progress, setProgress] = React.useState<number | null>(null);
    const [success, setSuccess] = React.useState('');
    const [page, setPage] = React.useState(1);
    const [count, setCount] = React.useState(1);

    const [selectedDateDe, setSelectedDateDe] = React.useState<Date | null>(() => {
        const date = new Date();
        return new Date(date.setMonth(date.getMonth() - 6));
    });

    const [selectedDateAte, setSelectedDateAte] = React.useState<Date | null>(
        new Date(),
    );

    const cnpj_or_cpf = useForm('notEmpty');
    const {loading, setLoading} = React.useContext(UserContext);
    
    const classes = useColorlibStepIconStyles();
    const classesAccordeon = useStyles();

    function changeGroup() {
        setGroup(!group);
    }

    const handleDateChangeDe = (date: Date | null) => {
        setSelectedDateDe(date);
    };

    const handleDateChangeAte = (date: Date | null) => {
        setSelectedDateAte(date);
    };

    async function searchRequests(pagination: number) {
        try {
            setLoading(true);
            setRequests([]);

            const {data} = await api.post('/requests', {
                cnpj_or_cpf: cnpj_or_cpf.value,
                group: group,
                initialDate: moment(selectedDateDe).format('YYYY-MM-DD'),
                finalDate: moment(selectedDateAte).format('YYYY-MM-DD'),
                page: pagination - 1,
                qpp: PedidosPorPagina,
            });
            
            if(data.requests === undefined || data.requests.length === 0) setInfo('Sem Resultados...');

            setRequests(data.requests);
            setCount(data.count);
        } catch (error) {
            // const result = (error as Error).message;
            const result = ('Não foram encontrados pedidos para o período selecionado')
            setError(result);
        } finally {
            setLoading(false);
        }
    }

    function doSearch(e: React.FormEvent): void {
        e.preventDefault();

        if (cnpj_or_cpf.validate()) {
            searchRequests(1);
        }
    }

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setError('');
    };

    function urlToPromise(url: any)  : any
    {
        return new Promise(function(resolve, reject) 
        {
            JSZipUtils.getBinaryContent(url, function (err: any, data: any) 
            {
                if(err) 
                {
                    reject(err);
                } else {
                    resolve(data);
                }
            });
        });
    }

    const generateZip = async (pedido: string) => {
        try {
            setProgress(0);                 

            const findRequest = requests.find(el => el.sNumeroPedido === pedido);
            if(!findRequest) return;

            var zip = new JSZip();
            zip.file("LEIA-ME.txt", "Obrigado por baixar imagens de nosso repositório!\n");
            const img = zip.folder("images");
    
            if(img === null) return;

            findRequest.products.forEach((data) => {    
                let name = data.sNomeArquivo;
                img.file(name, urlToPromise(process.env.REACT_APP_HIGH_IMAGE + name), {binary:true});                   
            });
                
            zip.generateAsync({type:"blob"}, function updateCallback(metadata) {
                setProgress(metadata.percent);
            }).then(function(content) {                    
                saveAs(content, `pedido-${pedido}.zip`);
                setSuccess('Arquivos baixados com sucesso!');
            }).catch((e) => {
                setError(e);
            }).finally(() => {
                handleCloseDownload();
            });             
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        }       
    }

    const handleCloseDownload = () => {
        setProgress(null);
    }

    const downloadXml = (xml: string, pedido: string) => {
        var blob = new Blob([xml], {type: "text/xml"});
        saveAs(blob, `xml-pedido_${pedido}.xml`);
        setSuccess('XML Baixado com sucesso!');
    }

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        searchRequests(value);
        window.scrollTo({top: 0, behavior: 'smooth'});
    }; 

    return (
        <Container>
            <AlertDark className={classes.alert} severity="info">
                Você pode selecionar a opção "Selecionar Grupo" para trazer todas as duplicatas relacionada á esse
                Código ou CNPJ/CNPJ.
            </AlertDark>
            <Form className="shadow" onSubmit={doSearch}>
                <Input label="Pesquisa por código do cliente, CNPJ ou CPF:" placeholder="Pesquisa por código do cliente, CNPJ ou CPF" id="cnpj_or_cpf"
                       type="text" {...cnpj_or_cpf}/>
                <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="De"
                        format="dd/MM/yyyy"
                        value={selectedDateDe}
                        onChange={handleDateChangeDe}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        className={classes.root}
                    />
                    <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Até"
                        format="dd/MM/yyyy"
                        value={selectedDateAte}
                        onChange={handleDateChangeAte}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>                
                <Submit>
                    <div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={group}
                                    onChange={changeGroup}
                                    name="group"
                                    color="primary"
                                />
                            }
                            label="Selecionar Grupo"
                        />
                    </div>                            
                    {loading ? <ButtonMine type="submit" disabled>Carregando...</ButtonMine> :
                        <ButtonMine type="submit">Pesquisar</ButtonMine>}
                </Submit>                
            </Form>
            <Grid>
                {
                    requests.map((el) => (
                        <AccordeonContainer className={classes.root} key={el.PK}>
                            <Accordion>
                                <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"                                
                                >
                                    <Alert severity="success">                      
                                        <Typography className={classesAccordeon.heading}>
                                            {el.sStatusPedido}
                                        </Typography>     
                                    </Alert>      
                                    <div className={classesAccordeon.heading}>
                                        <h2>{el.sNumeroPedido}</h2>
                                    </div>                                                           
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div>
                                        <p><strong>Razão:</strong> {el.sRazao}</p>
                                        <p><strong>Pedido:</strong> {el.sNumeroPedido}</p>
                                        <p><strong>sNFE:</strong> {el.sNFe}</p>
                                        <p><strong>Quantidade de Volumes:</strong> {el.sQtdeVolumes}</p>
                                        <p><strong>Quantidade de Itens:</strong> {el.iQtdeItens}</p>
                                        <p><strong>Status do Pedido:</strong> {el.sStatusPedido}</p>
                                        <p><strong>Pedido:</strong> {el.sNumeroPedido}</p>
                                        <p><strong>Data do Pedido:</strong> {moment(el.dtDataPedido).format('DD/MM/YYYY')}</p>
                                        <p><strong>Data de Saída:</strong> {moment(el.dtDataSaida).format('DD/MM/YYYY')}</p>
                                        <p><strong>Valor Total:</strong> {parseFloat(el.nValorTotalPedido).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>                                                                                                                                                          
                                    </div>
                                </AccordionDetails>
                                <div className={classes.rootAccordeon}>
                                    <div style={{minWidth: '100%', padding: '8px 16px 0', textAlign: 'left'}}>
                                        <h2>Itens do Pedido:</h2>
                                    </div>
                                    <ImageList className={classes.imageList} cols={2.5}>
                                        {el.products.map((item, index) => (
                                            <ImageListItem key={index}>
                                                <img src={item.average_image_url} alt={item.sCodigo} />
                                                <ImageListItemBar
                                                    title={item.sCodigo}
                                                    classes={{
                                                        root: classes.titleBar,
                                                        title: classes.title,
                                                    }}
                                                    actionIcon={
                                                        item.iRepositorio !== null ? 
                                                            <Link title={`Repositório ${item.iRepositorio}`} to={`${process.env.PUBLIC_URL}/usuario/repositorio/${item.iRepositorio}`}>
                                                                <IconButton aria-label={`star ${item.sCodigo}`}>
                                                                    <IoMdImages className={classes.title} />
                                                                </IconButton> 
                                                            </Link>
                                                        : null
                                                    }
                                                />
                                            </ImageListItem>
                                        ))}
                                    </ImageList>
                                </div>
                                <AccordionDetails>
                                    <div>
                                        <div>
                                            <Button
                                                variant="contained"
                                                color="default"
                                                size="large"
                                                disabled={el.xmlNFe === null}
                                                className={classes.button}
                                                startIcon={<CodeIcon/>}
                                                onClick={() => downloadXml(el.xmlNFe, el.sNumeroPedido)}
                                            >
                                                Baixar XML
                                            </Button>   
                                        </div>                                             
                                        <div>
                                            <CSVLink 
                                                data={el.products} 
                                                headers={headers}
                                                filename={`pedido-${el.sNumeroPedido}.csv`}
                                                onClick={() => setSuccess('XML Baixado com sucesso!')}
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    size="large"
                                                    startIcon={<DescriptionIcon/>}
                                                >
                                                    Baixar CSV
                                                </Button>
                                            </CSVLink>
                                        </div>
                                        <div>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                className={classes.button}
                                                startIcon={<CloudDownloadIcon/>}
                                                onClick={() => generateZip(el.sNumeroPedido)}
                                            >
                                                Baixar Imagens
                                            </Button> 
                                        </div>  
                                    </div>                                       
                                </AccordionDetails>
                            </Accordion>                        
                        </AccordeonContainer>
                    ))
                }
            </Grid>   
            {requests.length > 0 &&
                <div className={classesAccordeon.pagination}>
                    <Pagination count={Math.ceil(count / PedidosPorPagina)} size="large" page={page} onChange={handleChange}/>
                </div> 
            }                          
            <Snackbar open={error !== ''} autoHideDuration={3000} onClose={handleClose}>
                <AlertDark onClose={handleClose} severity="error">
                    {error}
                </AlertDark>
            </Snackbar>   
            <Snackbar open={info !== ''} autoHideDuration={3000} onClose={() => setInfo('')}>
                <AlertDark onClose={() => setInfo('')} severity="info">
                    {info}
                </AlertDark>
            </Snackbar>          
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={progress !== null}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={progress !== null}>
                    <div className={classesAccordeon.paper}>                        
                        {progress !== null &&
                            <>
                                <h1>Preparando seu Download</h1>
                                <p>Seu download irá começar assim que a barra abaixo estiver completa.</p>
                                <ProgressContent className="scroll-mac">
                                    <BorderLinearProgress variant="determinate" value={progress}/>
                                </ProgressContent>                            
                            </>
                        }                        
                    </div>
                </Fade>
            </Modal>
            <Snackbar open={success !== ''} autoHideDuration={3000} onClose={() => setSuccess('')}>
                <AlertDark severity="success" onClose={() => setSuccess('')}>
                    {success}
                </AlertDark>
            </Snackbar>
            <Snackbar open={error !== ''} autoHideDuration={3000} onClose={() => setError('')}>
                <AlertDark severity="error" onClose={() => setError('')}>
                    {error}
                </AlertDark>
            </Snackbar>
        </Container>
    )
}

export default MyRequests;